import API from '../config/axios'

const formAPI = {
	getRecords: () => {
		return API.get('/DataSetRecords')
			.then(res => res)
			.catch(err => err)
	},
	addRecord: (records, isNewForm, formTypes, version, operatorId = null, year = null, quarter = null) => {
		const payload = {
			formTypes,
			isNewForm,
			version: version,
			answers: records,
		}
		if (operatorId) {
			payload.operatorId = operatorId
			if (year) payload.year = year
			if (quarter) payload.quarter = quarter
		}
		return API.post('/DataSetRecords', payload)
			.then(res => res)
	},
	updateRecord: records => {
		return API.post('/DataSetRecords', records)
			.then(res => res)
			.catch(err => err)
	},
	excelUploading: (files, isNewForm, version, formTypes = []) => {
		const form = new FormData()
		form.append('isNewForm', isNewForm)
		form.append('fileUpload', files)
		form.append('version', version)

		if (formTypes && formTypes.length > 0) {
			formTypes.forEach(type => {
				form.append('formTypes', type)
			})
		}

		return API({
			url: '/DataSetRecords/ImportExcel',
			method: 'POST',
			data: form,
		})
			.then(res => res)
			.catch(err => {
				return err
			})
	},
	excelUploadingAdmin: (files, isNewForm, version, operatorId, year = null, quarter = null) => {
		const form = new FormData()
		form.append('isNewForm', isNewForm)
		form.append('fileUpload', files)
		form.append('version', version)
		if (operatorId) {
			form.append('operatorId', operatorId)
			if (year) form.append('year', year)
			if (quarter) form.append('quarter', quarter)
		}

		return API({
			url: '/DataSetRecords/ImportExcel',
			method: 'POST',
			data: form,
		})
			.then(res => res)
			.catch(err => {
				return err
			})
	},
	APIExcelUploading: (file, token, isAPI = false) => {
		const form = new FormData()
		form.append('fileUpload', file)

		return API({
			url: `/DataSetRecords/ImportExcel${isAPI ? '?method=api' : ''}`,
			method: 'POST',
			data: form,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})
			.then(res => res)
			.catch(err => {
				return false
			})
	},
	APIExternalExcelUploading: (file, token, isAPI = false) => {
		const form = new FormData()
		form.append('fileUpload', file)

		return API({
			url: `https://168.1.38.48/chativitpnbtcgoth-sydneyspacedev/main-prod/api/organizations`,
			method: 'POST',
			data: form,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})
			.then(res => res)
			.catch(err => {
				return false
			})
	},


	downloadDocument: () => {
		return API.get('/Document/doc1')
			.then(res => res)
			.catch(err => err)
	},
	getEvents: () => {
		return API.get('/DataSetRecords/events')
			.then(res => res)
			.catch(err => err)
	},
}
export default formAPI
